import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';

import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import { ActivityService } from '../../common/activity.service';
import {ListingService } from '../listing.service';

@Component({
  selector: 'app-add-discount',
  templateUrl: './add-discount.component.html',
  styleUrls: ['./add-discount.component.css', '../../app.component.css', '../admin.css'],
  providers: [ListingService]
})
export class AddDiscountComponent implements OnInit {
  userId : any;
  eventId :any;
  eventUserId:any;
  balance :any;
  discountForm: any;
  transType: any;
  spinner: boolean = false;
  amount: any;
  cardAmount:any;
  checkAmount:any;
   hideDetail:boolean = false;

  constructor(private router: Router, public dialogRef: MdDialogRef<AddDiscountComponent>, private snackBar: MdSnackBar,private formBuilder: FormBuilder, private ListingService: ListingService) {
    this.discountForm = this.formBuilder.group({
      "amount": ['', Validators.required],
      "userId": [''],
      "eventId":[''],
      "eventUserId":[''],
      "balanceAmt":[''],
      "transType":['']
    });
  }

  ngOnInit(){
    if(this.eventId && this.userId){
      this.discountForm.controls['userId'].patchValue(this.userId);
      this.discountForm.controls['eventId'].patchValue(this.eventId);
      this.discountForm.controls['eventUserId'].patchValue(this.eventUserId);
      this.discountForm.controls['transType'].patchValue(this.transType);
      this.discountForm.controls['balanceAmt'].patchValue(this.balance);
    }else{
      this.router.navigate(['./admin-event-listing']);
    }
  }

  close() {
    this.dialogRef.close();
  }

  addDiscount(){
    if(this.discountForm.valid){
        this.spinner = true;
        this.ListingService.addDiscount(this.discountForm.value).subscribe(
       response => {
        this.spinner = false;
        if(response.status)
        this.dialogRef.close(response);
        else
        this.snackBar.open(response.message,'',{duration:4000});
       },
       error => {
        this.spinner = false;
       }
     );
    }
  }

    hideDetails(){
        this.hideDetail=false;
    }

    getSplitAmount(){
        if(this.discountForm.valid){
            this.spinner = true;
            this.ListingService.getSplitAmt(this.discountForm.value).subscribe(
                    response => {
                    this.spinner = false;
                        this.hideDetail=true;
                        this.checkAmount=response.checkAmount;
                        this.cardAmount= response.cardAmount;
                },
                    error => {
                    this.spinner = false;
                }
            );
        }
    }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/add-discount/add-discount.component.ts